export default "__VITE_ASSET__BnnS5Jv___"